import styled from 'styled-components';

export const CurrentBenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 2;
  background-color: #fff;
  max-height: 800px;
  min-width: 500px;
`;

export const BenefitsTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; // Optional, adds space between the two texts
`;

export const CurrentBenefitsTitle = styled.p`
  font-size: 30px;
  font-weight: 600;
  color: #1c1b3a;
  padding: 10px 0 0 20px;
  margin-bottom: 10px;
`;

export const BiWeeklyText = styled.p`
  font-size: 14px; // Smaller font size
  font-weight: 600; // Same font weight as CurrentBenefitsTitle
  color: #1c1b3a; // Same color as CurrentBenefitsTitle
  padding: 0;

  margin-top: 49px; // Remove any margin
`;

export const CurrentBenefitsFooter = styled.div`
  display: flex;
  align-items: center;
  max-height: 50px;
  justify-content: flex-end;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 20px #00000029;
`;

export const CurrentBenefitsFooterText = styled.p`
  font-weight: 600;
  font-size: 18px;
  padding: 20px;
`;

export const CurrentBenefitsGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 10px 10px 10px 10px;
  column-gap: 20px;
  row-gap: 20px;
  height: 100%;
  overflow-y: scroll;
  margin: 20px 10px 10px 10px;
  @media only screen and (max-width: 1000px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (max-width: 980px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 750px) {
    grid-template-columns: repeat(1, 1fr);
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ColumnHeader = styled.div``;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: end;
  width: 100%;
  height: 100%;
`;
